import { __decorate } from 'tslib';
import { EventEmitter, ViewChild, Input, Output, Component, NgModule } from '@angular/core';
import axios from 'axios';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';

let UiCAsideMenuLeftComponent = class UiCAsideMenuLeftComponent {
    constructor() {
        this.version = '0.0.0';
        this.route = new EventEmitter();
    }
    ngAfterViewInit() { }
    ngOnInit() { }
    // abre o menu principal
    openMenu() {
        const menu = this.main.nativeElement;
        menu.classList.toggle('opened');
        if (!menu.classList.contains('opened')) {
            this.closeAll();
        }
    }
    // metodo para abertura do submenu
    openSubMenu(e, option) {
        e.preventDefault();
        const el = e.currentTarget;
        const parent = el.parentNode;
        const ul = parent.querySelector('ul');
        // fecha todos os submenus abertos
        this.closeAll(ul, () => {
            el.classList.toggle('enabled');
            ul.classList.toggle('enabled');
            this.changeIconSubMenu(el, ul, option);
        });
    }
    // deve fechar todos os submenus
    closeAll(element, callback) {
        const parent = this.parent.nativeElement;
        parent.querySelectorAll('.sub-menu').forEach((el) => {
            if (el !== element) {
                const opt = el.parentNode;
                opt.querySelector('a').classList.remove('enabled');
                el.classList.remove('enabled');
                this.changeIconSubMenu(opt, el);
            }
        });
        this.options.forEach((el) => {
            el.open = false;
        });
        // chama o callback
        if (callback !== undefined) {
            callback();
        }
    }
    // modifica o icone do link para abertura do submenu
    changeIconSubMenu(el, ul, option) {
        const icon = el.querySelector('ion-icon.icon-display-menu');
        if (ul.classList.contains('enabled')) {
            icon.name = 'chevron-down-outline';
        }
        else {
            icon.name = 'chevron-forward-outline';
        }
        if (option) {
            this.options.forEach((el) => {
                el.open = false;
                if (option != null && option.label == el.label && ul.classList.contains('enabled')) {
                    el.open = true;
                }
            });
        }
    }
    checkUrlType(url) {
        let flag = false;
        if (typeof url === 'string') {
            flag = true;
        }
        return flag;
    }
    iconMode(urlIcon) {
        if (urlIcon.split('/')[0] === 'assets') {
            return true;
        }
        else {
            return false;
        }
    }
    openUrl(url, parameters) {
        if (parameters === null) {
            window.open(url, '_blank');
        }
        else {
            this.openUrlInsurance(url, parameters);
        }
    }
    openUrlInsurance(url, parameters) {
        if (parameters !== null) {
            let xApiKey = JSON.parse(parameters)['x-api-key'];
            let campaignId = JSON.parse(parameters).campaignId;
            const headers = {
                'x-api-key': xApiKey,
            };
            const postData = {
                campaignId: campaignId,
                customer: {
                    email: '',
                    cellphone: '',
                    cpf: '',
                    name: '',
                    lastName: '',
                    birthdate: '',
                    address: {
                        zipCode: '',
                        street: '',
                        number: '',
                        complement: '',
                        district: '',
                        state: '',
                        city: '',
                    },
                },
            };
            axios.post(url, postData, { headers: headers }).then(result => {
                window.open(result.data.urls[2].url);
            });
        }
        else {
            window.open(url, '_blank');
        }
    }
};
__decorate([
    ViewChild('parentElement', { static: true })
], UiCAsideMenuLeftComponent.prototype, "parent", void 0);
__decorate([
    ViewChild('mainMenu', { static: true })
], UiCAsideMenuLeftComponent.prototype, "main", void 0);
__decorate([
    Input()
], UiCAsideMenuLeftComponent.prototype, "logoMenu", void 0);
__decorate([
    Input()
], UiCAsideMenuLeftComponent.prototype, "options", void 0);
__decorate([
    Input()
], UiCAsideMenuLeftComponent.prototype, "imgColor", void 0);
__decorate([
    Input()
], UiCAsideMenuLeftComponent.prototype, "version", void 0);
__decorate([
    Output()
], UiCAsideMenuLeftComponent.prototype, "route", void 0);
UiCAsideMenuLeftComponent = __decorate([
    Component({
        selector: 'ui-c-aside-menu-left',
        template: "<div (mouseenter)=\"openMenu()\" (mouseleave)=\"openMenu()\" id=\"menu-aside\" #mainMenu>\n  <div>\n    <nav>\n      <ul>\n        <li id=\"show-menu-btn\">\n          <a class=\"mb-0\" (click)=\"$event.preventDefault()\">\n            <img id=\"menu-brand\" [src]=\"logoMenu\" alt=\"\" />\n            <ion-icon class=\"icon\" name=\"chevron-forward-outline\"></ion-icon>\n          </a>\n        </li>\n      </ul>\n    </nav>\n    <nav id=\"nav-lateral\">\n      <ul #parentElement>\n        <!-- caminha entre o array de opcoes do menu -->\n        <ng-container *ngFor=\"let option of options\">\n          <!-- se a opcao for unica (sem sub menu) -->\n          <ng-container *ngIf=\"checkUrlType(option.url)\">\n            <li *ngIf=\"option.status === 'ACTIVE'\">\n\n\n              <a class=\"cursorLink\" *ngIf=\"iconMode(option?.iconWeb) === false && option?.category === 'PAGE'\" [routerLink]=\"option.url\">\n                <ion-icon class=\"icon\" [name]=\"option.iconWeb\"></ion-icon><span> {{ option.title }} </span>\n              </a>\n\n              <a class=\"cursorLink\" *ngIf=\"iconMode(option?.iconWeb) === false && option?.category === 'LINK' || option?.category === 'BROWSER'\" (click)=\"openUrl(option.url, option.parameters)\">\n                <ion-icon class=\"icon\" [name]=\"option.iconWeb\"></ion-icon><span> {{ option.title }} </span>\n              </a>\n\n              <a class=\"cursorLink\" *ngIf=\"iconMode(option?.iconWeb) === true && option?.category === 'MENU'\" [routerLink]=\"option.url\">\n                <ion-img [ngStyle]=\"imgColor\" class=\"icon img-icon\" src=\"{{option.iconWeb}}\"></ion-img><span> {{ option.title }} </span>\n              </a>\n\n              <a class=\"cursorLink\" *ngIf=\"iconMode(option?.iconWeb) === true && option?.category === 'PAGE' && option?.title !== 'Extrato'\" (click)=\"openUrl(option.url, option.parameters)\">\n                <ion-img [ngStyle]=\"imgColor\" class=\"icon img-icon\" src=\"{{option.iconWeb}}\"></ion-img><span> {{ option.title }} </span>\n              </a>\n\n              <a class=\"cursorLink\" *ngIf=\"iconMode(option?.iconWeb) === true && option?.category === 'PAGE'&& option?.title === 'Extrato'\" [routerLink]=\"option.url\">\n                <ion-img [ngStyle]=\"imgColor\" class=\"icon img-icon\" src=\"{{option.iconWeb}}\"></ion-img><span> {{ option.title }} </span>\n              </a>\n            </li>\n          </ng-container>\n\n          <!-- com sub menu -->\n          <ng-container *ngIf=\"!checkUrlType(option.url)\">\n            <li *ngIf=\"option.status === 'ACTIVE'\">\n              <a class=\"submenu-holder\" (click)=\"openSubMenu($event, option)\">\n                <ion-icon  *ngIf=\"iconMode(option?.iconWeb) === false\" class=\"icon\" [name]=\"option.iconWeb\"></ion-icon>\n                <ion-img *ngIf=\"iconMode(option?.iconWeb) === true\" [ngStyle]=\"imgColor\" class=\"icon img-icon\" [src]=\"option.iconWeb\"></ion-img>\n                <span> {{ option.title }} </span>\n                <ion-icon [class.hide]=\"true\" class=\"icon-display-menu\" name=\"chevron-forward-outline\"></ion-icon>\n                <ion-icon [class.hide]=\"option.open\" [name]=\"'chevron-forward-outline'\"></ion-icon>\n                <ion-icon [class.hide]=\"!option.open\" [name]=\"'chevron-down-outline'\"></ion-icon>\n              </a>\n              <ul class=\"sub-menu disabled\">\n                <li *ngFor=\"let sub of option.url\">\n                  <a [routerLink]=\"sub.url\">\n                    <ion-icon class=\"icon submenu-i\" name=\"ellipse\"></ion-icon> {{ sub.title }}\n                  </a>\n                </li>\n              </ul>\n            </li>\n          </ng-container>\n        </ng-container>\n        <!-- fim do loop das opcoes -->\n      </ul>\n    </nav>\n  </div>\n\n  <ion-grid class=\"footer-aside-menu-left\">\n    <ion-row class=\"ion-justify-content-center\">\n      <ion-col>\n        <div class=\"font-family-bold\" [innerHTML]=\"'v.' + version\"></div>\n      </ion-col>\n    </ion-row>\n  </ion-grid>\n</div>\n",
        styles: [".cursorLink{cursor:pointer}"]
    })
], UiCAsideMenuLeftComponent);

let UiCAsideMenuLeftModule = class UiCAsideMenuLeftModule {
};
UiCAsideMenuLeftModule = __decorate([
    NgModule({
        declarations: [UiCAsideMenuLeftComponent],
        imports: [
            CommonModule,
            IonicModule,
            RouterModule
        ],
        exports: [UiCAsideMenuLeftComponent]
    })
], UiCAsideMenuLeftModule);

/*
 * Public API Surface of ui-c-aside-menu-left
 */

/**
 * Generated bundle index. Do not edit.
 */

export { UiCAsideMenuLeftComponent, UiCAsideMenuLeftModule };
//# sourceMappingURL=wlp-ui-c-aside-menu-left.js.map
